var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAddSc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75783 18.5157C4.92859 18.5157 1 14.5871 1 9.75783C1 4.92859 4.92859 1 9.75783 1C14.5871 1 18.5157 4.92859 18.5157 9.75783C18.5157 14.5871 14.5871 18.5157 9.75783 18.5157ZM9.75783 1.74173C5.33612 1.74173 1.74173 5.33612 1.74173 9.75783C1.74173 14.1795 5.33612 17.774 9.75783 17.774C14.1795 17.774 17.7739 14.1795 17.7739 9.75783C17.7739 5.33612 14.1795 1.74173 9.75783 1.74173Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7678 23.4057C21.3318 23.4057 20.9202 23.2345 20.6146 22.9289L14.6197 16.9341C14.5504 16.8648 14.5098 16.7711 14.5098 16.6733C14.5098 16.5755 14.5504 16.4818 14.6197 16.4125L16.4047 14.6275C16.5474 14.4848 16.7838 14.4848 16.9264 14.6275L22.9212 20.6222C23.2309 20.932 23.3979 21.3395 23.3979 21.7755C23.3979 22.2116 23.2268 22.6232 22.9212 22.9289C22.6114 23.2386 22.2039 23.4057 21.7678 23.4057ZM15.4063 16.6733L21.1402 22.4072C21.4784 22.7455 22.0653 22.7455 22.4036 22.4072C22.5707 22.2401 22.6644 22.016 22.6644 21.7755C22.6644 21.5351 22.5707 21.3151 22.4036 21.1439L16.6696 15.4099L15.4063 16.6733Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7579 14.0983C9.55414 14.0983 9.38708 13.9312 9.38708 13.7275V5.78879C9.38708 5.58502 9.55414 5.41797 9.7579 5.41797C9.96167 5.41797 10.1288 5.58502 10.1288 5.78879V13.7275C10.1288 13.9312 9.96167 14.0983 9.7579 14.0983Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7272 10.1294H5.78854C5.58478 10.1294 5.41772 9.96228 5.41772 9.75851C5.41772 9.55475 5.58478 9.3877 5.78854 9.3877H13.7272C13.931 9.3877 14.0981 9.55475 14.0981 9.75851C14.0981 9.96228 13.931 10.1294 13.7272 10.1294Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddSc);
export default __webpack_public_path__ + "static/media/icon-add-sc.d3a29f208a6a2b6538548cd5236f35d1.svg";
export { ForwardRef as ReactComponent };